import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Droplets, Sun, Activity } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function ProblemSection() {
  const {
    t
  } = useLanguage();
  return <section className="pt-6 pb-12 bg-beige" data-id="element-297">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-298">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-299">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-3" data-id="element-300">
            {t('problem', 'title')}{' '}
            <span className="text-gold italic font-normal" data-id="element-301">
              {t('problem', 'titleHighlight')}
            </span>
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto mb-4" data-id="element-302"></div>
        </motion.div>

        <div className="prose prose-lg mx-auto text-dark/80 space-y-4 text-center md:text-left" data-id="element-303">
          <p className="text-xl font-medium text-dark" data-id="element-304">
            {t('problem', 'guess')}
          </p>
          <p data-id="element-305">{t('problem', 'tried')}</p>
          <p className="font-medium text-dark" data-id="element-306">{t('problem', 'stillHere')}</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-4" data-id="element-307">
            <div className="flex items-start space-x-4 bg-white p-6 rounded-sm shadow-sm border border-gold/10" data-id="element-308">
              <AlertCircle className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-309" />
              <p className="m-0" data-id="element-310">{t('problem', 'acne')}</p>
            </div>
            <div className="flex items-start space-x-4 bg-white p-6 rounded-sm shadow-sm border border-gold/10" data-id="element-311">
              <Sun className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-312" />
              <p className="m-0" data-id="element-313">{t('problem', 'spots')}</p>
            </div>
            <div className="flex items-start space-x-4 bg-white p-6 rounded-sm shadow-sm border border-gold/10" data-id="element-314">
              <Activity className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-315" />
              <p className="m-0" data-id="element-316">{t('problem', 'cellulite')}</p>
            </div>
            <div className="flex items-start space-x-4 bg-white p-6 rounded-sm shadow-sm border border-gold/10" data-id="element-317">
              <Droplets className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-318" />
              <p className="m-0" data-id="element-319">{t('problem', 'hair')}</p>
            </div>
          </div>

          <p className="text-xl font-medium text-dark text-center mt-4" data-id="element-320">
            {t('problem', 'notDifficult')}
          </p>
          <p className="text-center" data-id="element-321">{t('problem', 'wrongTreatment')}</p>
          <p className="text-center" data-id="element-322">{t('problem', 'generic')}</p>
          <p className="text-center font-medium text-gold-dark text-xl pt-2" data-id="element-323">
            {t('problem', 'doesntWork')}
          </p>
        </div>
      </div>
    </section>;
}